export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Block1_Mobile-a2f971d192d9cb974ec20a15f9ebda10.png";